/* src/app/views/doctor/doctors-list/doctors-list.component.css */
::ng-deep p-paginator svg {
  transform: rotate(180deg);
}
/*# sourceMappingURL=doctors-list.component.css.map */
